import { render } from "./AgendarQuadrasAdmView.vue?vue&type=template&id=2d58d269&scoped=true"
import script from "./AgendarQuadrasAdmView.vue?vue&type=script&lang=js"
export * from "./AgendarQuadrasAdmView.vue?vue&type=script&lang=js"

import "./AgendarQuadrasAdmView.vue?vue&type=style&index=0&id=2d58d269&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d58d269"]])

export default __exports__